import { render, staticRenderFns } from "./EmailToInvitee.vue?vue&type=template&id=079cd9d4&scoped=true"
import script from "./EmailToInvitee.vue?vue&type=script&lang=js"
export * from "./EmailToInvitee.vue?vue&type=script&lang=js"
import style0 from "./EmailToInvitee.vue?vue&type=style&index=0&id=079cd9d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079cd9d4",
  null
  
)

export default component.exports